import AccountTransferHistory from './components/AccountTransferHistory.js';
import connect from './connect';
import './assets/AccountTransferHistory.css';

export default connect(AccountTransferHistory);



// WEBPACK FOOTER //
// ./src/routes/AccountTransferHistory/index.js